import { useState, memo, useEffect } from 'react';
import { Slider, InputNumber } from 'antd';
import style from './index.module.scss';
import './index.scss';
import FatorBox from '../../components/FatorBox';
import { useTranslation } from 'react-i18next';

interface Props {
  initValue: number[];
  changeFator: (fator: { price__range: string | undefined }) => void;
}

const Price: React.FC<Props> = ({ changeFator, initValue }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<[number, number]>([0, 0]);
  const [minValue, setMinValue] = useState<number>(0);
  const [maxValue, setMaxValue] = useState<number>(0);
  // 进度条同步 input
  const hanldeAlignInput = (val: [number, number]) => {
    setMinValue(val[0]);
    setMaxValue(val[1]);
    changeFator({ price__range: val.join(',') });
  };
  const changeValue = (val: [number, number]) => {
    setValue(val);
    hanldeAlignInput(val);
  };
  const changeMin = (val: number) => {
    setMinValue(val);
    if (!!val && val !== maxValue) {
      const result: [number, number] = [val, +value[1]];
      setValue(result);
      changeFator({ price__range: result.join(',') });
    }
  };
  const changeMax = (val: number) => {
    setMaxValue(val);
    if (val && val !== minValue) {
      const result: [number, number] = [value[0], val];
      setValue(result);
      changeFator({ price__range: result.join(',') });
    }
  };
  const formatValue = (value: any): string =>
    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const parser = (value: any) => value!.replace(/\$\s?|(,*)/g, '');
  const reload = () => {
    setValue([0, 0]);
    setMinValue(0);
    setMaxValue(0);
    changeFator({ price__range: undefined });
  };
  useEffect(() => {
    if (initValue.length === 2) {
      setValue(initValue as [number, number]);
      setMinValue(initValue[0]);
      setMaxValue(initValue[1]);
    } else if (initValue.length === 1) {
      setValue([0, initValue[0]]);
      setMaxValue(initValue[0]);
    } else {
      setValue([0, 0]);
      setMinValue(0);
      setMaxValue(0);
    }
  }, [initValue]);
  return (
    <FatorBox title={t('mall.price')} reload={reload}>
      <div className="mall-fator-price">
        <Slider
          range
          min={0}
          max={10000}
          value={value}
          onChange={changeValue}
        />
        <div className={style.input}>
          <InputNumber
            min={0}
            max={maxValue}
            value={minValue}
            formatter={formatValue}
            parser={parser}
            onChange={changeMin}
          />
          <span className={style.sep}></span>
          <InputNumber
            min={minValue}
            value={maxValue}
            formatter={formatValue}
            parser={parser}
            onChange={changeMax}
          />
        </div>
      </div>
    </FatorBox>
  );
};

export default memo(Price);
